import Vue from 'vue';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { firestorePlugin } from 'vuefire';
import Buefy from 'buefy';
import contenteditableDirective from 'vue-contenteditable-directive';
import * as FullStory from '@fullstory/browser';

import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import AppConfig from '@/plugins/config/AppConfig';

store.subscribeAction((action) => {
  console.table([action.type, action.payload]);
});

Vue.config.productionTip = false;

const { env } = AppConfig.load();

FullStory.init({
  orgId: 'W0SH3',
  devMode: env !== 'prod',
});
Vue.prototype.$FullStory = FullStory;
Vue.use(AppConfig);
Vue.use(firestorePlugin);
Vue.use(Buefy);
Vue.use(contenteditableDirective);

let app = '';

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app');
  }
});
